import { createI18n } from 'vue-i18n';
import { get } from 'lodash';
import ko from './locales/ko.json';
import ja from './locales/ja.json';
import en from './locales/en.json';

export default createI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || 'en',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: { en: en, ko: ko, ja: ja },
    messageResolver: (obj, path) => get(obj, path, '')?.replaceAll(/@/g, "{'@'}") || null,
})